// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f4OHw","colMin":"styles_colMin__2duxk"};